import { render, staticRenderFns } from "./addStaffLeave.vue?vue&type=template&id=01e23f04&"
import script from "./addStaffLeave.vue?vue&type=script&lang=js&"
export * from "./addStaffLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports